module.exports = __webpack_public_path__ + "img/dsci0096.a3f05e33.jpg";